import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ARViewPage() {

  const location = useLocation();
  const navigate = useNavigate();

  const modelUrl =
    location.state?.modelUrl;

  const itemName =
    location.state?.itemName;

  const [isSupported, setIsSupported] =
    useState(null);

  // const [hasPermission, setHasPermission] =
  //   useState(false);



  const [loading, setLoading] =
    useState(true);

  // const [message, setMessage] =
  //   useState("Checking device...");

useEffect(() => {

  const checkDevice = async () => {

    try {

      if (!navigator.xr) {
        setIsSupported(false);
        setLoading(false);
        return;
      }

      const supported =
        await navigator.xr.isSessionSupported(
          "immersive-ar"
        );

      if (!supported) {
        setIsSupported(false);
        setLoading(false);
        return;
      }

      await checkCameraPermission();

      setIsSupported(true);

    } catch (error) {

      console.error(error);

      setIsSupported(false);

    }

    setLoading(false);

  };

  checkDevice();

}, []);
  // =========================
  // CAMERA PERMISSION
  // =========================

  const checkCameraPermission = async () => {

    try {

      const stream =
        await navigator.mediaDevices.getUserMedia({
          video: true,
        });

      // setHasPermission(true);

      stream.getTracks().forEach(
        (track) => track.stop()
      );

    } catch (error) {

      console.error(error);

      // setHasPermission(false);

      // setMessage(
      //   "Camera permission required"
      // );

    }

  };

  // =========================

  if (!modelUrl) {
    return (
      <div>
        Model not found
      </div>
    );
  }

  // =========================
  // LOADING SCREEN
  // =========================

  if (loading) {
    return (

      <div style={styles.center}>

        <div style={styles.loader} />

        <p>
          Preparing AR experience...
        </p>

      </div>

    );
  }

  // =========================
  // FALLBACK 3D VIEWER
  // =========================

  if (!isSupported) {
    return (

      <div style={styles.center}>

        <h2>
          AR Not Supported
        </h2>

        <p>
          Showing 3D model instead
        </p>

        <model-viewer
          src={modelUrl}
          camera-controls
          auto-rotate
          style={{
            width: "90%",
            height: "400px",
          }}
        />

        <button
          onClick={() => navigate(-1)}
          style={styles.backButton}
        >
          Go Back
        </button>

      </div>

    );
  }

  // =========================
  // MAIN AR VIEW
  // =========================

  return (

    <div
      style={{
        height: "100vh",
        background: "#000",
        position: "relative",
      }}
    >

      {/* BACK BUTTON */}

      <button
        onClick={() => navigate(-1)}
        style={styles.backButton}
      >
        ← Back
      </button>

      {/* SURFACE DETECTION MESSAGE */}

      <div style={styles.surfaceIndicator}>
        Move phone to detect surface...
      </div>

      {/* AR VIEWER */}

      <model-viewer
        src={modelUrl}
        alt={itemName}

        ar
        ar-modes="scene-viewer webxr quick-look"

        ar-placement="floor"
        ar-scale="auto"

        camera-controls
        auto-rotate

        shadow-intensity="1"

        style={{
          width: "100%",
          height: "100%",
        }}
      >

        <button
          slot="ar-button"
          style={styles.arButton}
        >
          Start AR
        </button>

      </model-viewer>

    </div>

  );

}

// =========================
// STYLES
// =========================

const styles = {

  center: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  loader: {
    width: "40px",
    height: "40px",
    border: "4px solid #eee",
    borderTop: "4px solid orange",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },

  backButton: {
    position: "absolute",
    top: 20,
    left: 20,
    zIndex: 10,
    padding: "10px 15px",
    background: "orange",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
  },

  surfaceIndicator: {
    position: "absolute",
    top: 20,
    right: 20,
    color: "white",
    background: "rgba(0,0,0,0.6)",
    padding: "8px 12px",
    borderRadius: "6px",
    zIndex: 10,
  },

  arButton: {
    position: "absolute",
    bottom: "20px",
    right: "20px",
    padding: "14px 18px",
    background: "orange",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
  }

};